<template>
<div class="row">
  <div class="col-md-6">
    <div class="product-thumbnail" :style="{backgroundImage: 'url('+ product._embedded['wp:featuredmedia'][0].source_url +')'}">
    </div>
  </div>
  <div class="col-md-6 d-flex flex-column justify-content-between">
    <ul class="list-unstyled font-size-0_7rem">
      <li v-for="typeId in product.type_note" :key="'type_note-'+typeId" :class="productTypeClass(typeId)">
        {{ typeName(typeId) }}
      </li>
    </ul>
    <div class="pb-3">
      <h6 class="h4">{{ brandName(product.brand[0]) }}</h6>
      <h5 class="h6 mb-4">{{ product.title.rendered }}</h5>
      <a :href="product.acf.shop_url" target="_blank" class="btn btn-layered py-2">
        <span class="py-2">official onlineStore</span>
        official onlineStore
      </a>
    </div>

  </div>
</div>
</template>

<script>
import {mapState} from 'vuex'

export default {
  name: 'ProductCell',
  props: {
    product: {
      type: Object,
      default: null
    },
    typeId: {
      type: Number,
      default: 0
    }
  },
  computed: {
    ...mapState({
      brands: state => state.brands,
      types: state => state.types,
    })
  },
  methods: {
    brandName(brandId) {
      if (!this.brands) {
        return ''
      }
      // console.log('brandId', brandId)
      for(let i=0; i<this.brands.length; i++) {
        if (this.brands[i].id == brandId) {
          return this.brands[i].name
        }
      }
      return ''
    },
    typeName(typeId) {
      if (!this.types) {
        return ''
      }
      // console.log('typeId', typeId)
      for(let i=0; i<this.types.length; i++) {
        if (this.types[i].id == typeId) {
          return this.types[i].name
        }
      }
      return '' + typeId
    },
    productTypeClass(typeId) {
      if (typeId == this.typeId) {
        return ''
      } else {
        return 'text-muted'
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.product-thumbnail {
  width: 250px;
  height: 250px;
  @media screen and (min-width: 768px){
    height: 217px;
    width: 100%;
  }
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}
</style>